import React from 'react';
import './Header.css';


const Header = () => {
  return (
    <header>
      <h1>Cryptocurrency Coins Visualisation Application</h1>
    </header>
  );
}

export default Header;
